const encoder = (value: string): string => btoa(value);

const decoder = (value: string): string => atob(value);

export { encoder, decoder };
